import React from 'react'
import DefaultButton from '../../components/DefaultButton'
// import { useModal } from '../../contexts/ModalContext';

export default function HomeResource() {
  // const { openQueryModal } = useModal();
  return (
    <>
      <section className="home-resource-area">
        <div className="row">
          <div className="col-lg-6 col-md-6 wow animate__animated animate__fadeInLeft" data-wow-duration="0.8s" data-wow-delay="0.1s">
            <div className="home-resource-left">
              <img src="/assets/images/home-resource-1.webp" alt="Resource"  loading='lazy'/>
              <div>
                <span className='heading'>Resource Center</span>
                <p>Stay informed with the latest insights from Dox and Box, including case studies, whitepapers, client success stories, expert perspectives.</p>
                <DefaultButton text={"Know More"} to={"/blog"}/>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 wow animate__animated animate__fadeInRight" data-wow-duration="0.8s" data-wow-delay="0.1s">
            <div className="home-resource-right">
              <img src="/assets/images/home-resource-2.webp" alt="Resource"  loading='lazy'/>
              <div className='text-center'>
                <h3 className="heading center-heading">Sustainable solutions built for efficiency and optimization</h3>
                <DefaultButton text={"Learn More"} to={"/sustainability"}/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
